import Box from '@mui/material/Box'
import metaUsageIcon from '../assets/icons/meta-usage.png'

type Props = Readonly<{
  /** Figma 37:1800 — faded usage icon on hidden platform cards */
  muted?: boolean
}>

/** Figma Repeat (node 37:1589 / 37:1820) — exported 10×10 asset */
export function MetaUsageIcon({ muted = false }: Props) {
  return (
    <Box
      component="img"
      src={metaUsageIcon}
      alt=""
      aria-hidden
      sx={{
        width: '10px',
        height: '10px',
        display: 'block',
        flexShrink: 0,
        opacity: muted ? 0.4 : 1,
      }}
    />
  )
}
